// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-area[data-v-01a691d9] {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #acabab;\n  border-radius: 4px;\n  min-height: 30px;\n}\n.label-text-area[data-v-01a691d9] {\n  top: -12px;\n  left: 11px;\n  background: white;\n  padding: 0px 4px 0px 4px;\n}", ""]);
// Exports
module.exports = exports;
